import { PButton } from 'components/prime/PButton/PButton';
import { PMessage } from 'components/prime/PMessage/PMessage';
import styled from 'styled-components';

export const PasswordsChangeFormStyle = {
  Form: styled.div``,
  Button: styled(PButton)`
    margin-top: 10px;
  `,
  PasswordCheckerBox: styled.div`
    margin-bottom: 22px;
  `,
  Message: styled(PMessage)`
    margin-bottom: 32px;
  `,
};
